import {
  ActiveFeatureFlags,
  JsonCredential,
  JsonDownloadParams,
} from '@accredible-frontend-v2/models';
import { RecipientApiService } from '@accredible-frontend-v2/recipient-api';
import { AccredibleRecipientFeatureFlagsService } from '@accredible-frontend-v2/services/feature-flags';
import {
  downloadFileFromData,
  fileTypeExtensions,
} from '@accredible-frontend-v2/utils/download-file-helper';
import { inject, Injectable } from '@angular/core';
import { map, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CredentialDownloadFacade {
  private readonly _recipientFeatureFlags = inject(AccredibleRecipientFeatureFlagsService);
  private readonly _recipientApi = inject(RecipientApiService);

  readonly hasOb3W3cDownload$ = this._recipientFeatureFlags
    .loadFeatureFlags()
    .pipe(map((features) => features[ActiveFeatureFlags.OB3_W3C_DOWNLOAD]));

  downloadJsonCredential(credentialId: string, downloadParams: JsonDownloadParams): void {
    this._recipientApi
      .downloadJsonCredential(credentialId, downloadParams)
      .pipe(
        tap((response) => {
          'image_url' in response
            ? this._downloadBakedBadge(response.image_url)
            : this._downloadAsJson(response, downloadParams.export_format, credentialId);
        }),
      )
      .subscribe();
  }

  private _downloadAsJson(data: JsonCredential, format: string, credentialId: string): void {
    const jsonString = JSON.stringify(data, null, 2);
    downloadFileFromData(
      jsonString,
      `credential-${format}-${credentialId}`,
      fileTypeExtensions.JSON,
    );
  }

  private _downloadBakedBadge(imageUrl: string): void {
    window.open(imageUrl, '_blank');
  }
}
